import { makeAutoObservable } from 'mobx';
import { inject, injectable } from 'inversify';
import { type AuthService, AuthServiceIdentifier } from '@shared/types/mobx/services/auth';
import { formatPhone } from '@/shared/utils/helpers/formatString';

@injectable()
export class LoginViewModel {
  constructor(@inject(AuthServiceIdentifier) private authModule: AuthService) {
    makeAutoObservable(this);
    this._phone = formatPhone(window.history.state?.usr?.phone);
  }

  private _phone: string | null = null;

  get phone() {
    return this._phone;
  }

  set phone(value: string | null) {
    this._phone = value;
  }

  authUser = async (code: string) => {
    if (!this._phone) return;

    await this.authModule.authUser(this._phone, code);
  };
}
